import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const PurchaseQuotesListView = lazy(() =>
	import('./components/views/PurchaseQuotesListView').then((module) => ({
		default: module.PurchaseQuotesListView
	}))
);

/**
 * The Purchase Quotes routes.
 */
const purchaseQuotesRoutes: FuseRouteItemType[] = [
	{
		path: 'purchase-quotes',
		element: <PurchaseQuotesListView />
	}
];

export default purchaseQuotesRoutes;
